import { render, staticRenderFns } from "./DataAnalysisDashboardPivotEditModalComponent.vue?vue&type=template&id=54caa0ef"
import script from "./DataAnalysisDashboardPivotEditModalComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardPivotEditModalComponent.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysisDashboardPivotEditModalComponent.vue?vue&type=style&index=0&id=54caa0ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports